// extracted by mini-css-extract-plugin
export default {"button":"custombutton_button__SJm2s"};